var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenderDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6473 29.0037C18.0199 29.0031 17.4292 28.7082 17.0516 28.2071C16.674 27.7061 16.5533 27.057 16.7255 26.4537L16.9836 25.5533C17.0355 25.3742 17.0617 25.1886 17.0616 25.0021C17.0616 23.8971 16.1658 23.0012 15.0608 23.0012H12.9969C11.8919 23.0012 10.9961 22.1054 10.9961 21.0004V20C10.9961 19.914 10.9961 19.8269 10.9961 19.7409C11.0638 17.3537 12.0772 15.0912 13.8133 13.4512C15.5493 11.8112 17.8658 10.9282 20.2529 10.9962C25.01 11.1746 28.8253 14.9899 29.0036 19.7469C29.0036 19.8329 29.0036 19.919 29.0036 20.005C29.0008 24.9757 24.9705 29.0037 19.9998 29.0037H18.6473Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0012 19.7229C24.8615 19.7234 24.7487 19.837 24.7491 19.9766C24.7494 20.1163 24.8628 20.2293 25.0025 20.2291C25.1421 20.2289 25.2553 20.1156 25.2553 19.976C25.2555 19.9086 25.2288 19.8439 25.1811 19.7964C25.1333 19.7488 25.0685 19.7223 25.0012 19.7229",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0226 14.7478C19.9201 14.7482 19.8279 14.8105 19.7892 14.9055C19.7506 15.0004 19.773 15.1094 19.8461 15.1813C19.9192 15.2532 20.0285 15.274 20.1228 15.2338C20.2172 15.1936 20.278 15.1005 20.2767 14.9979C20.277 14.9305 20.2503 14.8658 20.2025 14.8183C20.1548 14.7707 20.09 14.7443 20.0226 14.7448",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.506 16.1984C16.3665 16.1995 16.2542 16.3133 16.2549 16.4528C16.2557 16.5924 16.3692 16.705 16.5087 16.7046C16.6482 16.7042 16.7611 16.591 16.7611 16.4515C16.7614 16.384 16.7345 16.3191 16.6866 16.2715C16.6386 16.2239 16.5736 16.1976 16.506 16.1984",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5441 23.2393C23.4045 23.2399 23.2917 23.3534 23.292 23.4931C23.2924 23.6328 23.4058 23.7457 23.5455 23.7455C23.6851 23.7454 23.7982 23.6321 23.7982 23.4924C23.7988 23.425 23.7721 23.3601 23.7243 23.3125C23.6765 23.2649 23.6116 23.2385 23.5441 23.2393",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5441 16.1984C23.4045 16.199 23.2917 16.3125 23.292 16.4522C23.2924 16.5918 23.4058 16.7048 23.5455 16.7046C23.6851 16.7044 23.7982 16.5912 23.7982 16.4515C23.7988 16.384 23.7721 16.3192 23.7243 16.2716C23.6765 16.224 23.6116 16.1976 23.5441 16.1984",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderDesign);
export default __webpack_public_path__ + "static/media/tenderDesign.08c2879ce58ab87f5ca5ecb5250224e9.svg";
export { ForwardRef as ReactComponent };